import React from 'react';
import ButtonComponent from '../../../../../../components/button/buttonComponent';

export interface ProfileInfoField {
  subtitle?: string;
  label?: string;
  value?: string | string[] | undefined[] | null;
  renderCustom?: React.ReactNode;
  hidden?: boolean;
  separator?: string | boolean;
}

interface ProfileInfoSectionProps {
  title: string;
  fields: ProfileInfoField[];
  goToEdit?: () => void;
}

export const ProfileInfoSection: React.FC<ProfileInfoSectionProps> = ({
  title,
  fields,
  goToEdit,
}) => (
  <div className="flex flex-col items-center w-full">
    <div className="flex w-full gap-5">
      <h2 className="self-start font-semibold text-xl text-btn-black">
        {title}
      </h2>

      {goToEdit && (
        <ButtonComponent
          testID={`go-to-edit-${title}`}
          type="underline"
          onClick={goToEdit}
          fullWidthClassName="w-fit desktop:w-full"
        >
          Edit
        </ButtonComponent>
      )}
    </div>

    <hr className="my-2.5 bg-[#00000026] w-full h-px" />

    {fields.map((field, index) =>
      !field.hidden ? (
        <React.Fragment>
          {field.separator && <hr className=" bg-[#00000026] w-full h-px" />}
          <div key={index} className="flex flex-col desktop:flex-row w-full">
            <div className="flex desktop:flex-row mobile:flex-col py-[15px] w-full">
              {field.subtitle && (
                <label className="w-full desktop:w-5/12 text-lg text-charcoal-gray font-semibold">
                  {field.subtitle}
                </label>
              )}

              {field.label && (
                <label className="w-full text-btn-black desktop:w-5/12 text-base font-semibold">
                  {field.label}
                </label>
              )}

              <div className="w-full desktop:w-7/12">
                {field.renderCustom ? (
                  field.renderCustom
                ) : Array.isArray(field.value) ? (
                  field.value.map((item, idx) => (
                    <span key={idx} className="text-med-gray font-semibold">
                      {item}
                      {idx < (field.value as string[]).length - 1 && ', '}
                    </span>
                  ))
                ) : (
                  <p className="text-med-gray-3 font-medium">{field.value}</p>
                )}
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : null,
    )}
  </div>
);
